/* eslint-disable no-shadow */
import Cookies from 'js-cookie';
import { getOssUrl, getMenu } from '@/api';
import communityMenu from '@/utils/communityMenu';
import utils from '@/utils';

const pathArr = window.location.pathname.split('/');
const typeArr = utils.SYS_KEYS;

let [curSysKey] = typeArr;
if (pathArr && pathArr.length >= 3) {
  [, , curSysKey] = pathArr;
  if (!typeArr.includes(curSysKey)) [curSysKey] = typeArr;
}

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true, withoutAnimation: false
  },
  oss_base_url: '',
  tempMenu: [],
  courseMenu: [],
  ticketMenu: [],
  communityMenu,
  curSysKey // course(课程) ticket(票务) community(社区)
};

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_SIZE: (state, size) => {
    state.size = size;
    Cookies.set('size', size);
  },
  SET_OSS_URL: (state, url) => {
    state.oss_base_url = url;
  },
  SET_MENU: (state, data) => {
    state.tempMenu = data;
  },
  CHANGE_SYS(state, key) {
    state.curSysKey = key;
  }
};

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  async getOssUrl({ commit, state, dispatch }) {
    if (!state.oss_base_url) {
      const res = await getOssUrl();
      if (res && res.data) {
        commit('SET_OSS_URL', res.data.oss_base_url);
        return res.data.oss_base_url;
      }
      dispatch('msg/showErrorMsg', res.msg || '获取OSS文件域名失败！', { root: true });
    }
    return state.oss_base_url;
  },
  async getMenu({ commit, state }, playload = 'course') {
    if (playload === 'course') {
      const res = await getMenu();
      if (res && res.data) {
        /* res.data.push({
          id: 161, meta: { icon: null, title: '操作日志' }, name: 'logger', path: '/logger', parent_id: null
        });
        console.log(res.data); */
        commit('SET_MENU', res.data);
        return true;
      }
    } else if (playload === 'ticket') {
      commit('SET_MENU', state.ticketMenu);
      return true;
    } else if (playload === 'community') {
      commit('SET_MENU', state.communityMenu);
      return true;
    }
    return false;
  },
  changeSys({ commit, state, dispatch }, key) {
    commit('CHANGE_SYS', key);
    if (state[`${key}Menu`].length === 0) {
      dispatch('getMenu', key);
    } else {
      commit('SET_MENU', state[`${key}Menu`]);
    }
  }
};

export default {
  namespaced: true, state, mutations, actions
};
